import NavigationBar from '../widgets/NavigationBar';
import { Box, Grid } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import '../../styles/history.scss';
import HistoryBarGraph, { Period } from '../widgets/HistoryBarGraph';
import SquareDisplay from '../widgets/SquareDisplay';
import useChargingHistory from '../../hooks/useChargingHistory';
import { getCookie } from '../../data/Cookies';
import { useEffect, useState } from 'react';
import formatOrdinal from '../../hooks/ordinalFormater.js';
import useStatistics from '../../hooks/useStatistics';
  
const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', flex: 1.1, headerClassName: "header", sortable: false },
    { field: 'duration', headerName: 'Duration', flex: 1, headerClassName: "header", sortable: false },
    { field: 'energy', headerName: 'Energy', flex: 1, headerClassName: "header", sortable: false },
    { field: 'emissions', headerName: 'CO2', flex: 1, headerClassName: "header", sortable: false },
    { field: 'solar', headerName: 'Solar', flex: 1, headerClassName: "header", sortable: false }
];

export default function History() {
    let id = getCookie("id");

    const {history, getHistory} = useChargingHistory();

    const {statistics, getStatistics} = useStatistics();

    const [period, receivePeriod] = useState(Period.week);
    

    useEffect(() => {
        getHistory();
        getStatistics();
        updateTable(history);
    }, [JSON.stringify(history)])

    useEffect(() => {
        getStatistics();
        updateSquareDisplays();
    }, [JSON.stringify(statistics)])

    useEffect(() => {
        updateTable(history);
        updateSquareDisplays();
    }, [period])

    const [squareDisplayData, setSquareDisplayData] = useState({left: -1, center: -1, right: -1});

    function updateSquareDisplays() {
        if (statistics === undefined) return;

        var newSquareDisplayData = {left: -1, center: -1, right: -1};
        newSquareDisplayData["left"] = statistics[period]["emissions"];
        newSquareDisplayData["center"] = statistics[period]["energy"];
        newSquareDisplayData["right"] = statistics[period]["duration"];
        
        setSquareDisplayData(newSquareDisplayData);
    }

    function updateTable(data) {
        if (data === undefined) return;

        data = data[period];

        var dataRows : any = [];
        var id = 0;
        data.forEach((entry) => {
            if (entry.length != 0) {
                var dateFormat;

                if (period === Period.year) {
                    dateFormat = entry.date;
                } else {
                    const date = new Date (entry.date);
                    dateFormat = formatOrdinal(date.getDate()) + " " + date.toLocaleString('en-US', { month: 'short' });
                }

                var newRow = {
                    id: id,
                    date: dateFormat,
                    duration: entry.duration,
                    energy: entry.energy,
                    emissions: entry.emissions,
                    solar: entry.solar
                };

                id ++;
                dataRows.push(newRow);
            }
        })

        setRows(dataRows);
    }

    const [rows, setRows] = useState([{id: 0}]);

    return(
        <Grid
            className = "layoutGrid"
            container
            direction = "row">

            <Grid item xs = {12} className = "squareDisplaySpace">
                <SquareDisplay topLabel={period} centerLabel={squareDisplayData.left} bottomLabel='CO2 emissions'/>
                <SquareDisplay topLabel={period} centerLabel={squareDisplayData.center} bottomLabel='Energy'/>
                <SquareDisplay topLabel={period} centerLabel={squareDisplayData.right} bottomLabel='Charge time'/>
            </Grid>

            <Grid item xs = {12} className = "graphDisplaySpace">
                <HistoryBarGraph passPeriod = {receivePeriod}/>
            </Grid>
            
            <Grid item xs = {12} className = "tableDisplaySpace">
            <Box className = "borderBox">
                <h1 className = "tableTitle">Charge History</h1>
                <DataGrid
                    className = "chargeHistoryTable"
                    rowHeight = {30}
                    rows={rows}
                    columns={columns}
                    hideFooter
                    disableColumnMenu />
            </Box>
            </Grid>

            <Grid item xs = {12}>
                <NavigationBar/>
            </Grid>
        </Grid>
    );
}
